const ACCESS_KEY = "roott_access_token";
const REFRESH_KEY = "roott_refresh_token";
const USER_KEY = "roott_user";

const normAccess = (v?: string | null) => (!v ? null : v.startsWith("Bearer ") ? v : `Bearer ${v}`);

export function saveTokens(access: string, refresh?: string) {
  const a = normAccess(access);
  if (a) localStorage.setItem(ACCESS_KEY, a);
  if (typeof refresh === "string" && refresh.length) localStorage.setItem(REFRESH_KEY, refresh);
}

export function setTokensFromResponse(d: any) {
  const access = d?.access ?? d?.access_token ?? d?.token ?? null;
  const refresh = d?.refresh ?? d?.refresh_token ?? null;
  if (access) localStorage.setItem(ACCESS_KEY, normAccess(access)!);
  if (refresh) localStorage.setItem(REFRESH_KEY, refresh);
  return Boolean(access || refresh);
}

export function getAccess(): string | null {
  return localStorage.getItem(ACCESS_KEY);
}

export function getRefresh(): string | null {
  return localStorage.getItem(REFRESH_KEY);
}

export function clearTokens() {
  localStorage.removeItem(ACCESS_KEY);
  localStorage.removeItem(REFRESH_KEY);
}

export function saveUser(user: any | null) {
  if (user == null) {
    localStorage.removeItem(USER_KEY);
  } else {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }
}

export function getUser<T = any>(): T | null {
  const raw = localStorage.getItem(USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as T;
  } catch {
    return null;
  }
}

export function authHeader() {
  const access = getAccess();
  return access ? { Authorization: access } : {};
}

export function hasTokens() {
  return { hasAccess: !!getAccess(), hasRefresh: !!getRefresh() };
}
